"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormEditor = void 0;
const editor_1 = require("../../../components/editor/editor");
const form_field_1 = require("./form-field");
exports.FormEditor = form_field_1.formFieldFactory(editor_1.Editor);
//# sourceMappingURL=form-editor.js.map